var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "card",
          attrs: { shadow: "always" },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.addTotalActivity },
                  },
                  [_vm._v("新增")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "location" }, [
              _vm._v("\n                总条数:"),
              _c("span", [_vm._v(_vm._s(_vm.pager.total))]),
            ]),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, border: "" } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "id", label: "ID" },
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "title", label: "名称" },
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "img", label: "封面图" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.img
                          ? _c("el-image", {
                              attrs: {
                                src: _vm.getImg(scope.row.img),
                                "preview-src-list": [_vm.getImg(scope.row.img)],
                              },
                            })
                          : _c("div", [_vm._v("暂无图片")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "num", label: "排序" },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", align: "center", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.row.status == 1 ? "下架" : "上架") +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "categoryId", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.particularsEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑/查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("DialogAddEdit", {
        ref: "DialogAddEdit",
        attrs: { dialogVisible: _vm.dialogVisible },
        on: {
          "update:dialogVisible": function ($event) {
            _vm.dialogVisible = $event
          },
          "update:dialog-visible": function ($event) {
            _vm.dialogVisible = $event
          },
          reloadData: _vm.reloadData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }